class LatencyManager
{
	static HasInit = false;
	static Handlers = {};

	static init()
	{
		if(this.HasInit === true) {
			console.log("[LATENCY MANAGER] Already init. Not doing anything");
			return;
		}

		this.HasInit = true;

		console.log("[LATENCY MANAGER] Setting up Latency Manager to measure client ping against our Data Centres..");

		if(!DataCentreList) {
			console.log("[LATENCY MANAGER] No Data Centre list specified. Not doing anything.");
			return;
		}

		Object.keys(DataCentreList).forEach((key) => {

			const dc = DataCentreList[key];

			this.Handlers[key] = {
				Datacentre: dc,
				Handler: new LatencyTester(dc.endpoint, key)
			};

		});

	}

	static hasPing(id)
	{
		return (this.Handlers[id] !== undefined);
	}

	static getPing(id)
	{
		if(!this.Handlers[id]){
			return 0;
		}

		return this.Handlers[id].Handler.CurrentPing ?? 0;

	}

}

window.LatencyManager = LatencyManager;
